// TransationApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'Transation'];

// Enhance the base API service by adding entication-related tag types
const TransationApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new 
        createTransation: build.mutation({
            query: ({ transaction,order_id, user_id }) => ({
              url: `/transactions/${order_id}/${user_id}`,
              method: 'POST',
              data: transaction,  // Using ShopProfile interface data here
            }),
            invalidatesTags: ['Transation'],  // Invalidate ShopProfiles tags after creation
          }),
      // Fetch Transation query (GET request to /me)
      getTransation: build.query({
        query: (userId) => ({
          url: `/transactions/user/${userId}`,
        }),
        providesTags: ['Transation'],
      }), 
       // Fetch transactions for a user (GET request to /user-transactions)
       getUserTransactions: build.query({
        query: ({ userId, isActive, page, size }) => ({
          url: '/transactions/user-transactions',
          method: 'GET',
          params: {
            userId,
            isActive,
            page,
            size,
          },
        }),
        providesTags: ['Transation'],
      }),
      
      // Delete   mutation (DELETE request  )
      deleteResquedAmount: build.mutation({
        query: (id) => ({
          url: `/transactions/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Transation'], // Invalidate the user tag after deletion
      }),  
    }),
    overrideExisting: false,
  });

export default TransationApi;

// Exporting hooks for each endpoint to be used in components
export const {
    useCreateTransationMutation,
   useGetTransationQuery,
   useGetUserTransactionsQuery,
   useDeleteResquedAmountMutation
    
} = TransationApi;


